import { Col, message, Row } from 'antd';
import { IconCopy } from '../../../../../assets/index';
import moment from 'moment';
import * as React from 'react';
import { isEmpty } from '../../../../../utils/helpers/helpers';
import usePromotion from '../../../../../hooks/usePromotion';
import './MobilePromotion.scss';
import MobileBreadCrumb from '../../MobileBreadCrumb/MobileBreadCrumb';

const MobilePromotion = (props) => {
  const { promo } = usePromotion({});
  return (
    <div className='mobile-promotion'>
      <div className='wrap-promo'>
        <div className='container-home'>
          <MobileBreadCrumb />
          <div className='title-promotion '>Mã ưu đãi</div>
          <div className='desc-promo'>
            <span className='desc'>
              Mã ưu đãi là cách tối ưu để tăng hoa hồng cho bạn và khuyến khích
              người dùng đặt dịch vụ.
              <br /> Chỉ cần người dùng đặt dịch vụ bằng mã ưu đãi bạn chọn, bạn
              sẽ nhận được một phần doanh thu!
            </span>
          </div>
          <div className='list-promo'>
            <Col style={{ width: '100%' }}>
              {!isEmpty(promo) &&
                promo.map((el, index) => (
                  <Col style={{ width: '100%' }} key={el?.code}>
                    <div className='promo' key={index}>
                      <div className='box-left'>
                        <span className='tittle'>{el.title}</span>
                        <span className='date'>
                          Áp dụng đến:
                          {!isEmpty(el.expiredTime) &&
                            moment(el.expiredTime).format('DD/MM/YYYY')}
                        </span>
                      </div>
                      <div className='box-right'>
                        <span className='circle' />
                        <span className='code'>{el.code}</span>
                        <span
                          className='wrap-copy'
                          onClick={() => {
                            navigator.clipboard.writeText(el.code);
                            message.success('Sao chép mã thành công!');
                          }}
                        >
                          <div className='icon-copy'>
                            <IconCopy />
                          </div>
                          Sao chép mã
                        </span>
                        <span className='circle-bottom' />
                      </div>
                    </div>
                  </Col>
                ))}
            </Col>
          </div>

          {/* <div className='list-description'>
            <Row>
              <Col span={12}>
                <div className='box-left'>
                  <span>- Dành cho khách hàng đặt qua ứng dụng mytour</span>
                  <span>- Mỗi khách hàng được sử dụng 01 lần</span>
                </div>
              </Col>
              <Col span={12}>
                <div className='box-right'>
                  <span>- Dành cho khách hàng đặt qua website mytour.vn</span>
                  <span>- Mỗi khách hàng được sử dụng 01 lần</span>
                </div>
              </Col>
            </Row>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default MobilePromotion;
